exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".kZsrWUGCSUQY1QYPQYStw{border-bottom:.07143rem solid #ccc;margin:1.42857rem 0 .71429rem 1.07143rem;-webkit-transition-duration:0ms;-moz-transition-duration:0ms;-o-transition-duration:0ms;transition-duration:0ms}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"InternalNotesPart_addNote": "_1Z0wRRPOxn-Bv9pOGbhsJH",
	"InternalNotesPart_line": "kZsrWUGCSUQY1QYPQYStw"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/SessionReport/GrammarPro/InternalNotes/style.postcss
// module id = 1898
// module chunks = 0